import { useTranslation } from "react-i18next";
import { useToast } from "../components/Toast";
import { openHappytalk } from "../utils/happytalk";

export default function useHappytalk() {
  const { t } = useTranslation();
  const toast = useToast();
  return () => {
    openHappytalk().catch(() => toast.show(t("contact.chatError"), "error"));
  };
}
